import { useEffect } from 'react';

// React の画面ではなく、public/ に置いた独立したページ（例: /trooper/ の製品LP）へ移る。
// 画面内のリンクから来たときもページを読み込み直して、そのページを開く。
export default function StaticPage({ to }) {
  useEffect(() => {
    window.location.replace(to + window.location.hash);
  }, [to]);
  return null;
}
